export default "__VITE_ASSET__$VayDcE$__"